import { CashFlowIncomeSellingItem } from 'bus/cash/types/cashFlowIncomeSelling';

export const initValue: CashFlowIncomeSellingItem = {
  cashFlowItemId: null,
  comment: '',
  date: '',
  receivedSum: 0,
  remainderSum: 0,
};
